export default function CaseStudies() {
  const cases = [
    {
      company: '某AI科技公司',
      industry: '人工智能',
      logo: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20company%20logo%20design%20with%20AI%20artificial%20intelligence%20theme%2C%20clean%20geometric%20shapes%2C%20teal%20and%20blue%20color%20scheme%2C%20professional%20corporate%20branding%2C%20simple%20white%20background&width=200&height=200&seq=logo-001&orientation=squarish',
      challenge: '年研发投入超3亿元，涉及20多个研发项目，人工核算耗时长且易出错',
      solution: '部署RDCost系统后，实现研发数据自动归集，费用核算时间从2个月缩短至3天',
      result: '成功申请研发费用加计扣除9000万元，节省税款超1500万元',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20CEO%20executive%20portrait%20wearing%20business%20suit%20with%20confident%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%20photography%2C%20high%20quality%20professional%20image&width=100&height=100&seq=ceo-001&orientation=squarish',
      name: '张总',
      position: '首席财务官',
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      company: '某生物医药企业',
      industry: '生物医药',
      logo: 'https://readdy.ai/api/search-image?query=Modern%20pharmaceutical%20biotech%20company%20logo%20design%20with%20medical%20cross%20and%20molecule%20elements%2C%20clean%20professional%20style%2C%20teal%20and%20green%20color%20palette%2C%20corporate%20branding%2C%20simple%20white%20background&width=200&height=200&seq=logo-002&orientation=squarish',
      challenge: '高新技术企业认定材料准备复杂，研发费用占比难以精确计算',
      solution: '使用RDCost智能生成高新认定所需全套材料，确保数据准确性和完整性',
      result: '顺利通过高新技术企业认定，享受15%企业所得税优惠税率',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20CFO%20executive%20portrait%20wearing%20business%20attire%20with%20warm%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%20photography%2C%20high%20quality%20professional%20image&width=100&height=100&seq=cfo-001&orientation=squarish',
      name: '李总',
      position: '研发总监',
      gradient: 'from-teal-500 to-green-500'
    },
    {
      company: '某新能源汽车公司',
      industry: '新能源汽车',
      logo: 'https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20automotive%20company%20logo%20design%20with%20lightning%20bolt%20and%20car%20silhouette%2C%20clean%20minimalist%20style%2C%20teal%20and%20silver%20color%20scheme%2C%20professional%20corporate%20branding%2C%20simple%20white%20background&width=200&height=200&seq=logo-003&orientation=squarish',
      challenge: '多地研发中心，费用分散，项目管理混乱，预算超支严重',
      solution: '建立统一的研发项目管理平台，实时监控各地研发费用使用情况',
      result: '项目预算准确率提升至95%，研发投入产出比提高40%',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20CTO%20technology%20executive%20portrait%20wearing%20casual%20business%20attire%20with%20friendly%20expression%2C%20clean%20white%20background%2C%20corporate%20headshot%20photography%2C%20high%20quality%20professional%20image&width=100&height=100&seq=cto-001&orientation=squarish',
      name: '王总',
      position: '技术副总裁',
      gradient: 'from-purple-500 to-indigo-500'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-b from-gray-50 via-white to-gray-50 relative overflow-hidden">
      {/* 装饰性背景 */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-teal-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '2s' }}></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center bg-gradient-to-r from-teal-50 to-blue-50 text-teal-700 px-5 py-2.5 rounded-full text-sm font-semibold mb-5 border border-teal-100 shadow-sm">
            <i className="ri-trophy-line mr-2"></i>
            客户案例
          </div>
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-5">
            他们都在使用
            <span className="block mt-2 bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
              智研云
            </span>
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            来自不同行业的领先企业，都选择智研云作为研发费用管理的得力助手
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {cases.map((item, index) => (
            <div 
              key={index}
              className="relative bg-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 group cursor-pointer overflow-hidden border-2 border-gray-100 hover:border-transparent"
            >
              {/* 悬停渐变背景 */}
              <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>

              <div className="relative z-10">
                <div className="flex items-center mb-8">
                  <div className="relative">
                    <div className={`absolute -inset-1 bg-gradient-to-r ${item.gradient} rounded-2xl blur opacity-30 group-hover:opacity-50 transition-opacity`}></div>
                    <img 
                      src={item.logo}
                      alt={item.company}
                      className="relative w-16 h-16 object-cover object-top rounded-xl shadow-lg"
                    />
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-bold text-gray-900 group-hover:text-teal-700 transition-colors">{item.company}</h4>
                    <p className="text-sm text-gray-500 flex items-center">
                      <i className="ri-building-line mr-1"></i>
                      {item.industry}
                    </p>
                  </div>
                </div>

                <div className="space-y-6 mb-8">
                  <div className="relative pl-6">
                    <div className="absolute left-0 top-1 w-5 h-5 flex items-center justify-center bg-orange-100 rounded-full">
                      <i className="ri-error-warning-line text-orange-600 text-sm"></i>
                    </div>
                    <div className="text-sm font-bold text-gray-700 mb-2">面临挑战</div>
                    <p className="text-gray-600 text-sm leading-relaxed">{item.challenge}</p>
                  </div>

                  <div className="relative pl-6">
                    <div className="absolute left-0 top-1 w-5 h-5 flex items-center justify-center bg-blue-100 rounded-full">
                      <i className="ri-lightbulb-line text-blue-600 text-sm"></i>
                    </div>
                    <div className="text-sm font-bold text-gray-700 mb-2">解决方案</div>
                    <p className="text-gray-600 text-sm leading-relaxed">{item.solution}</p>
                  </div>

                  <div className="relative pl-6">
                    <div className="absolute left-0 top-1 w-5 h-5 flex items-center justify-center bg-teal-100 rounded-full">
                      <i className="ri-trophy-line text-teal-600 text-sm"></i>
                    </div>
                    <div className="text-sm font-bold text-gray-700 mb-2">实施效果</div>
                    <p className="text-teal-700 text-sm font-semibold leading-relaxed">{item.result}</p>
                  </div>
                </div>

                <div className="border-t-2 border-gray-100 pt-6 flex items-center">
                  <div className="relative">
                    <div className={`absolute -inset-0.5 bg-gradient-to-r ${item.gradient} rounded-full blur opacity-40`}></div>
                    <img 
                      src={item.avatar}
                      alt={item.name}
                      className="relative w-12 h-12 rounded-full object-cover object-top shadow-md"
                    />
                  </div>
                  <div className="ml-4">
                    <div className="font-bold text-gray-900">{item.name}</div>
                    <div className="text-sm text-gray-500">{item.position}</div>
                  </div>
                  <div className="ml-auto">
                    <i className="ri-double-quotes-r text-4xl text-gray-200 group-hover:text-teal-200 transition-colors"></i>
                  </div>
                </div>
              </div>

              {/* 装饰性角标 */}
              <div className={`absolute -top-2 -right-2 w-24 h-24 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-10 rounded-full blur-2xl transition-opacity duration-500`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
